import React from "react";
import { Modal } from "@mui/material";
import HPBaseModal from "@components/common/HPBaseModal";

const DEFAULT_TITLE = "Switch to All eligible respondents?";
const DEFAULT_MESSAGE =
  "Your custom base name and conditions will be kept while you're editing, but the chart won't use them unless you switch back to Custom base before saving.";

interface DisableCustomBaseConfirmDialogProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  /** Destination-specific copy; defaults to the "All eligible respondents" wording. */
  title?: string;
  message?: string;
}

const DisableCustomBaseConfirmDialog: React.FC<DisableCustomBaseConfirmDialogProps> = ({
  open,
  onCancel,
  onConfirm,
  title = DEFAULT_TITLE,
  message = DEFAULT_MESSAGE,
}) => {
  if (!open) return null;

  return (
    <Modal
      open={open}
      onClose={onCancel}
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <div style={{ width: 440, outline: "none" }}>
        <HPBaseModal
          title={title}
          message={message}
          cancelButtonText="Cancel"
          confirmButtonText="Switch"
          onCancel={onCancel}
          onConfirm={onConfirm}
        />
      </div>
    </Modal>
  );
};

export default DisableCustomBaseConfirmDialog;
